export interface FacetItem {
  value: string;
  count: number;
}

interface MergeRemoteFacetItemsInput {
  initialItems: FacetItem[];
  remoteItems: FacetItem[];
  selectedValues?: string[];
}

export function mergeRemoteFacetItems(input: MergeRemoteFacetItemsInput): FacetItem[] {
  const itemsByValue = new Map(input.remoteItems.map((item) => [item.value, item]));
  const selectedValues = new Set(input.selectedValues ?? []);

  for (const item of input.initialItems) {
    if (selectedValues.has(item.value) && !itemsByValue.has(item.value)) {
      itemsByValue.set(item.value, item);
    }
  }

  return [...itemsByValue.values()];
}
